import React from "react"
import WithBlocks from "./WithBlocks"

const WithBlock = props => {
    return (
        <WithBlocks>
            {({ blocks, onChange, createBlock }) => {
                const matches = blocks.filter(block => block._sid === props.blockId)
                if (!matches.length) return props.loading ? this.props.loading : ""
                const block = matches[0]

                return props.children({
                    block,
                    onChange: dict => onChange(block._sid, dict),
                    createBlock,
                })
            }}
        </WithBlocks>
    )
}

export default WithBlock



// WEBPACK FOOTER //
// ./src/data/wrappers/WithBlock.js